import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=24719c7e&scoped=true"
import script from "./Bonuses.vue?vue&type=script&lang=js"
export * from "./Bonuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24719c7e",
  null
  
)

export default component.exports